import React from 'react';
export function Button({
  children,
  className = ''
}: {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}) {
  return <button onClick={() => document.getElementById('offer')?.scrollIntoView({
    behavior: 'smooth'
  })} className={`bg-gold hover:bg-yellow-600 text-white font-bold py-4 px-8 rounded-xl shadow-xl transform transition duration-300 hover:-translate-y-1 hover:shadow-2xl text-xl md:text-2xl w-full md:w-auto text-center ${className}`} data-id="element-10">
      {children}
    </button>;
}